import QRCode from "qrcode"

import { adapter } from "@/utils/sdk"

export const getUrl = (
    uid?: string | number | null,
    shareType: "qrCode" | "link" = "qrCode"
) => {
    const origin = window.location.origin
    const pathname = window.location.pathname

    const source_from = adapter.source.from
    const shareBy = uid ? window.btoa(String(uid)) : ""

    const params = new URLSearchParams()
    source_from && params.append("source_from", source_from)
    params.append("share_type", shareType)
    shareBy && params.append("share_by", shareBy)
    const paramStr = params.toString()

    const result = `${origin}${pathname}?${paramStr}`

    return result
}

export async function drawQRCode({
    uid,
    canvas,
    size,
}: {
    uid?: string | number | null
    canvas?: HTMLCanvasElement | null
    size: number
}) {
    canvas = canvas || document.createElement("canvas")
    canvas.width = size * 16
    canvas.height = size * 16

    const content = getUrl(uid)

    await QRCode.toCanvas(canvas, content, {
        errorCorrectionLevel: "M",
        margin: 1,
        width: size * 16,
        height: size * 16,
        color: {
            dark: "#000000",
            light: "#00000000",
        },
    })

    return canvas.toDataURL("image/png")
}
